import { motion, AnimatePresence } from "framer-motion";
import { CheckCircle2, AlertCircle, Info, X } from "lucide-react";
import { useStore } from "../../store/useStore";
import { cn } from "../../utils/helpers";

export const ToastSystem = () => {
  const { notifications, removeNotification } = useStore();

  return (
    <div className="fixed bottom-6 right-6 z-[100] flex flex-col gap-2 pointer-events-none">
      <AnimatePresence>
        {notifications.map((n) => (
          <motion.div
            key={n.id}
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.95 }}
            layout
            className={cn(
              "pointer-events-auto min-w-[320px] p-4 rounded-xl shadow-2xl border flex items-center gap-3 backdrop-blur-xl",
              n.type === "success" &&
                "bg-emerald-50/90 dark:bg-emerald-950/50 border-emerald-200 dark:border-emerald-800 text-emerald-800 dark:text-emerald-100",
              n.type === "error" &&
                "bg-rose-50/90 dark:bg-rose-950/50 border-rose-200 dark:border-rose-800 text-rose-800 dark:text-rose-100",
              n.type === "info" &&
                "bg-white/90 dark:bg-slate-900/90 border-slate-200 dark:border-slate-800 text-slate-800 dark:text-slate-100",
            )}
          >
            {n.type === "success" && <CheckCircle2 size={18} />}
            {n.type === "error" && <AlertCircle size={18} />}
            {n.type === "info" && <Info size={18} />}

            <p className="text-sm font-medium flex-1">{n.message}</p>

            <button
              onClick={() => removeNotification(n.id)}
              className="opacity-50 hover:opacity-100"
            >
              <X size={14} />
            </button>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};
